import LoggerFactory from 'utilities/loggerv2/loggerFactory';
import ErrorCodes from 'utilities/loggerv2/errorCodes';
import { Customer } from 'types/CustomerTypes';
import { Logger } from 'utilities/loggerv2/logger';
import { CustomerServiceInterface } from './interface/CustomerServiceInterface';
import { startSpan, endSpan, failSpan } from '../../utilities/loggerv2/performanceSpans';

export default class CustomerService {
  private customerService: CustomerServiceInterface;

  private logger: Promise<Logger>;

  constructor(customerService: CustomerServiceInterface) {
    this.customerService = customerService;
    this.logger = LoggerFactory.getLogger('Customer service');
  }

  async getCustomer(): Promise<Customer> {
    const span = startSpan('getCustomer');

    try {
      const response = await this.customerService.getCustomer();

      endSpan(span, {
        success: true,
      });

      return response;
    } catch (error) {
      (await this.logger).logWithCode(ErrorCodes.CUSTOMER_GET_CUSTOMER_FAILED, error);

      failSpan(span, {
        code: 'CUSTOMER_GET_CUSTOMER_FAILED',
        errorType: ErrorCodes.CUSTOMER_GET_CUSTOMER_FAILED.code,
        message: error?.message || ErrorCodes.CUSTOMER_GET_CUSTOMER_FAILED.message,
      });

      return {};
    }
  }
}
